@if (formField.scope === 'GLOBAL' || formField.scope === 'LOCAL' || formField.real === false) {
  <div [formGroup]="form">
    <label [matTooltip]="getFieldTooltip()">{{ formField.name }} @if (formField.required) {
      <span
        style="color: red; position: relative; top: 3px;"
      >*</span>
    }</label>
    <div class="flex-100" >
      @if (formField.type === 'TEXT') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="(formField.tag === 'TAG' || formField.jsonProperty === 'defaultTag') ?
                       pickValidationFunction(formField) : null" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'NUM') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
              (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'BOOL') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill" class="flex-align-center flex-100"
            [matTooltip]="formField.jsonProperty === 'disabled' ? getFieldTooltip() : ''">
            <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
              @for (option of formField.options; track option) {
                <mat-option
                [value]="option.value" [disabled]="selectedFeatureScope === 'Viewer'">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'TEXTAREA') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <textarea matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              [formControlName]="formField.jsonProperty" class="flex-100"
              >
            </textarea>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'SELECT') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill" class="flex-align-center flex-100"
            [matTooltip]="formField.jsonProperty === 'disabled' ? getFieldTooltip() : ''">
            <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
              @for (option of formField.options; track option) {
                <mat-option
                [value]="option.value" [disabled]="selectedFeatureScope === 'Viewer'">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'MULTI_SELECT') {
        <div
          [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()"
          (mouseover)="selectedFeatureScope === 'Viewer' ? setTooltipToFieldValue(formField.jsonProperty) : null"
          [matTooltip]="overrideTooltip | async">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <mat-select [formControlName]="formField.jsonProperty"
              multiple class="flex-100">
              <mat-option *ngFor="let option of formField.options as Array"
              [value]="option.value" [disabled]="isOptionDisabled(option)">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'IMAGE') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
              (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
    </div>
    <div class="action-buttons-container">
      <div class="stacked-icons">
        @if (formField.scope === 'LOCAL' && !formField.required && !(hasParentOverride$ | async)) {
          <div>
            @if (selectedFeatureScope === 'Global') {
              <button
                class="remove-attribute"
                mat-icon-button
                matTooltip="Remove Attribute"
                tabIndex="-1"
                type="button"
                (click)="handleRemoveLocalAttribute(formField)"
                >
                <mat-icon>delete_forever</mat-icon>
              </button>
            }
            @if (formField.jsonProperty === 'defaultTag') {
              <span
                class="material-symbols-outlined default-tag-tooltip">
                <mat-icon matTooltip="First item will become Default Tag if selected value is disabled">
                  info
                </mat-icon>
              </span>
            }
          </div>
        }
        @if (formField.scope === 'LOCAL' && (hasParentOverride$ | async)) {
          <div>
            <span class="material-symbols-outlined required-local-attribute">
                    <mat-icon [matTooltip]="'This dynamic attribute has an override at the parent level, ' +
                    (parentOverride | async)">info</mat-icon>
            </span>
          </div>
        }
        @if (formField.scope === 'LOCAL' && formField.required && formField.jsonProperty === 'modifierType') {
          <div>
            <span class="material-symbols-outlined required-local-attribute">
              <mat-icon matTooltip="This is a required attribute for Dressing, Condiments, Ingredients, and Sauces.">info</mat-icon>
            </span>
          </div>
        }
      </div>
      @if (selectedFeatureScope !== 'Client') {
        <div class="list-icon">
          <button
            mat-icon-button
            matTooltip="View values for {{ formField.name }} by location"
            tabIndex="-1"
            type="button"
            (click)="openViewOverridesDialog()"
            >
              <img class="icon three-lanes" ngSrc="assets/img/three-lanes.svg" alt="Three Lanes Icon" height="24" width="24"/>
          </button>
        </div>
      }
    </div>
  </div>
}
